/** Small async-state helpers shared by admin modules. */
import type { ReactNode } from "react";
import { AlertTriangle, Inbox, Loader2 } from "lucide-react";
import { errorMessage } from "../lib/admin";

export function LoadingCard({ label = "Loading…" }: { label?: string }) {
  return (
    <div className="admin-card" style={{ display: "flex", alignItems: "center", gap: 10, padding: 24 }}>
      <Loader2 size={16} className="spin" />
      <span className="ev-body-muted">{label}</span>
    </div>
  );
}

export function ErrorCard({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  return (
    <div className="admin-card" style={{ padding: 24 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <AlertTriangle size={18} style={{ color: "var(--ev-red-600)" }} />
        <span className="ev-body">{errorMessage(error)}</span>
        {onRetry && (
          <button className="ev-btn ev-btn-sm ev-btn-outline" onClick={onRetry}>
            Retry
          </button>
        )}
      </div>
    </div>
  );
}

export function EmptyState({ children }: { children: ReactNode }) {
  return (
    <div
      className="admin-card"
      style={{ padding: 40, display: "flex", flexDirection: "column", alignItems: "center", gap: 8 }}
    >
      <Inbox size={22} style={{ color: "var(--ev-slate-400)" }} />
      <span className="ev-body-muted">{children}</span>
    </div>
  );
}
